import React from 'react';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

const UserListHdr = () => {
  return (
    <TableHead>
      <TableRow>
        {
          ['Email', 'Role', 'Date Created'].map((item, idx) => {
            return (
              <TableCell key={idx} align='center' style={{ height: 48 }}>{item}</TableCell>
            );
          })
        }
      </TableRow>
    </TableHead>
  );
};

export default React.memo(UserListHdr);